import { render, staticRenderFns } from "./ExternalRecords.vue?vue&type=template&id=1889b533&scoped=true"
import script from "./ExternalRecords.vue?vue&type=script&lang=js"
export * from "./ExternalRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1889b533",
  null
  
)

export default component.exports